import { login, resetPassword } from './login'
import { refresh } from './refresh'
import { getSessions } from './getSessions'
import { terminateSession } from './terminateSession'
import { resetPasswordToken } from './reset-password-token'
import { validatePasswordToken } from './validate-password-token.js'
import { changePassword } from './change-password'
import { createJWTokens } from './createJWTokens'
import { getSession } from '@/libs/api/auth/getSession.js'
import { getWsToken } from '@/libs/api/auth/getWsToken.js'

const api = {
  login,
  refresh,
  getSession,
  getSessions,
  terminateSession,
  resetPassword,
  resetPasswordToken,
  validatePasswordToken,
  changePassword,
  createJWTokens,
  getWsToken,
}

export default api
